import { ButtonV3 } from '@zola/zola-ui/src/components/ButtonV3';
import { useResponsiveDesign } from '@zola/zola-ui/src/contexts/ResponsiveDesignContext/ResponsiveDesignContext';
import MEDIA_QUERY_V2 from '@zola/zola-ui/src/styles/emotion/mediaQueryV2';
import SPACING from '@zola/zola-ui/src/styles/emotion/spacing';
import { Title3 } from '@zola/zola-ui/src/typography/Headings';

import styled from '@emotion/styled';

import ClientApp from '~/ClientApp';
import { VendorCardVendor } from '~/components/common/cards/util/types';
import VendorCardShelf from '~/pages/couples/explore/components/VendorCardShelf/VendorCardShelf';

import { PageSection } from '../PageSection/PageSection';

type MostPopularShelfProps = {
  cardList: VendorCardVendor[];
  viewAllHref: string;
};

const TitleButtonContainer = styled.div`
  display: flex;
  justify-content: space-between;
  margin-bottom: ${SPACING.S24};

  ${MEDIA_QUERY_V2.EXCLUDE_MOBILE} {
    margin-bottom: ${SPACING.LG};
  }
`;

const MostPopularShelf = ({ cardList, viewAllHref }: MostPopularShelfProps) => {
  const { isMobile } = useResponsiveDesign();
  if (!cardList.length) return null;
  return (
    <ClientApp>
      <PageSection>
        <TitleButtonContainer>
          <Title3>Most popular venues</Title3>
          <ButtonV3 component="a" href={viewAllHref}>
            View all {!isMobile && 'venues'}
          </ButtonV3>
        </TitleButtonContainer>
        <VendorCardShelf cardList={cardList} />
      </PageSection>
    </ClientApp>
  );
};

export default MostPopularShelf;
